module.exports = __webpack_public_path__ + "logo_full-dcde4c833a006ee82d8032fecee7b3bd.png";